import React from 'react';
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody
} from '@chakra-ui/react';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';
import { Trans, t } from '@lingui/macro';
import { handInQtc } from '../mle/mle-actions';
import { useLocalisation } from '../../helpers/i18n/use-localisation';
import { BtnText } from '../../components/buttons';
import css from './footer-qtc.scss';

const HandIn = ({
  isOpen,
  onClose
}) => {
  const dispatch = useDispatch();
  const { i18n } = useLocalisation();
  const submitNow = () => {
    dispatch(handInQtc());
    onClose();
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      size="xl"
      isCentered
    >
      <ModalOverlay />
      <ModalContent
        borderRadius="16"
      >
        <ModalHeader
          textAlign="center"
          mt="20px"
        >
          <Trans>
            Submit your assessment?
          </Trans>
        </ModalHeader>
        <ModalBody
          textAlign="center"
          mb="20px"
        >
          {i18n._(t`Once you submit, you will not be able to change any answers, even if
          there is time remaining. You can review and edit your answers until the
          timer ends. Are you sure you want to submit now?`)}
        </ModalBody>

        <ModalFooter
          display="flex"
          justifyContent="center"
          mb="20px"
        >
          <BtnText
            className={css['btn-keep-working']}
            callBack={onClose}
            type="secondary"
          >
            <Trans>Keep Working</Trans>
          </BtnText>
          <BtnText
            className={css['btn-submit-now']}
            callBack={submitNow}
            type="secondary"
          >
            <Trans>Submit Now</Trans>
          </BtnText>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

HandIn.propTypes = {
  isOpen: PropTypes.function,
  onClose: PropTypes.function
};

export default HandIn;
